<template>
  <section class="offers">
    <div :class="['offers__head', $store.state.config.coins.background]">
      <div class="offers__japanese">
        ナ<br>ル<br>ト
      </div>

      <!-- <PictoKunai class="offers__kunai" />
      <PictoSpiral class="offers__spiral" />
      <PictoStar class="offers__star offers__star--left" />
      <PictoStar class="offers__star offers__star--right" /> -->

      <div class="offers__packshots">
        <div
          v-for="(product, index) in products"
          :key="`coins-packshot_${product.id}`"
          class="offers__packshot"
        >
          <FlipPic
            class="offers__pic"
            :recto="product.face"
            :verso="product.revers"
            :flipped="flipped[index]"
            @click.native="$set(flipped, index, !flipped[index])"
          />

          <div
            class="offers__picflip picto-reverse-coin"
            @click="$set(flipped, index, !flipped[index])"
          />
        </div>
      </div>

      <div
        class="offers__flip picto-reverse-coin"
        @click="flipAllCoins"
      />
    </div>

    <div class="offers__cards">
      <Card
        v-for="product in products"
        :key="`coins_${product.id}`"
        class="offers__card"
        :product="product"
      />
    </div>
  </section>
</template>

<script>
import FlipPic from '@/components/products/FlipPic.vue';
// import PictoKunai from '@/components/pictos/PictoKunai.vue';
// import PictoSpiral from '@/components/pictos/PictoSpiral.vue';
// import PictoStar from '@/components/pictos/PictoStar.vue';
import Card from './Card.vue';

export default {
  components: {
    Card,
    FlipPic,
    // PictoKunai,
    // PictoSpiral,
    // PictoStar,
  },

  data() {
    return {
      flipped: { type: Array, default: () => [] },
    };
  },

  computed: {
    products() {
      return this.$store.state.config.coins.products;
    },
  },

  methods: {
    flipAllCoins() {
      this.products.forEach((product, index) => {
        this.$set(this.$data.flipped, index, !this.$data.flipped[index]);
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.offers__head {
  position: relative;

  width: auto;
  height: auto;
  margin-bottom: 30px;
  padding: 108px 0 80px 0;

  overflow: hidden;
  border: 2px solid black;
  border-radius: 30px;
  background-repeat: repeat;

  +desktop() {
    padding: 85px 0;
  }
}

.offers__japanese {
  @extends $txt-offers-japanese;

  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);

  color: $cl-secondary;
  text-align: center;
  white-space: nowrap;

  br { display: none; }

  +desktop() {
    top: 50%;
    left: auto;
    right: 30px;
    transform: translateY(-50%);

    br { display: inline; }
  }
}

.offers__spiral {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translateX(100px);
  >>> path { fill: white; }

  +desktop() {
    top: 20px;
    transform: translateX(-440px);
  }

  +above(xl) { transform: translateX(-570px); }
}

.offers__star {
  position: absolute;
  >>> path { fill: $cl-secondary; }
}

.offers__star--left {
  top: 90%;
  right: 50%;
  transform: translateX(-100px) scale(0.75);

  +desktop() {
    top: 85%;
    transform: translateX(-370px) scale(0.75);
  }

  +above(xl) { transform: translateX(-520px) scale(0.75); }
}

.offers__star--right {
  display: none;
  top: 20px;
  left: 50%;
  transform: translateX(100px);

  +desktop() { display: block; }
}

.offers__kunai {
  position: absolute;
  top: 90%;
  left: 50%;
  display: none;
  transform: translateX(100px) scale(1.6) rotate(260deg);

  >>> path { fill: $cl-secondary; }

  +desktop() { display: block; }

  +above(xl) { transform: translateX(480px) scale(1.6) rotate(210deg); }
}

.offers__packshots {
  +desktop() {
    display: flex;
    justify-content: center;
    gap: 60px;
  }
}

.offers__packshot {
  position: relative;
  width: 300px;
  margin: -30px auto 0 auto;

  +desktop() {
    flex: 1;
    max-width: 408px;
    margin: 0;
  }

  &:first-child {
    position: relative;
    z-index: 1;
    margin-top: 0;
  }
}

.offers__pic {
  cursor: pointer;
}

.offers__picflip,
.offers__flip {
  position: absolute;
  cursor: pointer;
}

.offers__picflip {
  display: none;
  right: 10%;
  bottom: 10%;

  +desktop() { display: block; }
}

.offers__flip {
  right: 10px;
  bottom: 20px;

  width: 60px;
  height: @width;

  background-size: 100%;

  +desktop() { display: none; }
}

.offers__cards {
  margin: 0 auto;

  +desktop() {
    display: flex;
    justify-content: center;
    gap: 60px;
  }
}

.offers__card {
  flex: 1;
  margin: 0 auto 60px auto;
  max-width: 408px;

  +desktop() { margin: 0; }
}
</style>
